import React from 'react';
import CircleIcon from '@mui/icons-material/Circle';
import { useParties } from '../contexts/PartiesContext';

interface ActionNeededIndicatorProps {
  receiver: string;
  isOffered: boolean;
}
export const ActionNeededIndicator: React.FC<ActionNeededIndicatorProps> = ({
  isOffered,
  receiver,
}) => {
  const { party } = useParties();

  return (
    <CircleIcon
      color="secondary"
      sx={{
        visibility: isOffered && party === receiver ? 'visible' : 'hidden',
        mr: 0,
        display: 'flex',
        scale: 0.5,
      }}
      fontSize="small"
    />
  );
};
